import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { List } from "@/components/admin/list";
import { ReferenceField } from "@/components/admin/reference-field";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";

const filters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput
    source="status"
    alwaysOn
    choices={[
      { id: "review", name: "Requiere revisión" },
      { id: "associated", name: "Asociado" },
      { id: "ignored", name: "Ignorado" },
    ]}
  />,
];

export const EmailList = () => (
  <List filters={filters} sort={{ field: "received_at", order: "DESC" }}>
    <DataTable rowClick="edit">
      <DataTable.Col source="status" />
      <DataTable.Col source="sender_email" />
      <DataTable.Col source="subject" />
      <DataTable.Col source="snippet" />
      <DataTable.Col source="company_id" label="Empresa">
        <ReferenceField source="company_id" reference="companies" />
      </DataTable.Col>
      <DataTable.Col source="contact_id" label="Contacto">
        <ReferenceField source="contact_id" reference="contacts" />
      </DataTable.Col>
      <DataTable.Col source="received_at" field={DateField} />
      <DataTable.Col source="provider" />
    </DataTable>
  </List>
);
